export default __webpack_public_path__ + "static/media/socialHero.0b793d0d.jpg";